import axios from '../API/axios';

export const getP4DTracking = (trackingNumber: string) => {
  return axios.get(`tracking/p4d/${trackingNumber}`);
};